import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IClienteData } from '@core/interfaces/entidades/cliente.entidad';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import { IClienteCrearReq } from '@core/interfaces/request-response/cliente.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class ClienteApiService extends BaseHttpService {
  paginar(pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.get<IPaginar<IClienteData>>(
        `${environment.apiUrl}${environment.apiPreFix}/cliente/v2/paginar`,
        {
          params,
        },
      ),
    );
  }
  buscarCoincidencia(termino: string) {
    const params = new HttpParams().set('q', termino);
    return this.withLoader(
      this.httpClient.get<IClienteData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/cliente/v2/buscar-coincidencia`,
        {
          params: params,
        },
      ),
    );
  }
  crear(req: IClienteCrearReq) {
    return this.httpClient.post<IClienteData>(
      `${environment.apiUrl}${environment.apiPreFix}/cliente/v2/crear`,
      req,
    );
  }
  eliminar(clienteId: number) {
    return this.httpClient.delete<void>(
      `${environment.apiUrl}${environment.apiPreFix}/cliente/v2/eliminar/${clienteId}`,
    );
  }
  editar(clienteId: number, req: Partial<IClienteData>) {
    return this.httpClient.put<IClienteData>(
      `${environment.apiUrl}${environment.apiPreFix}/cliente/v2/editar/${clienteId}`,
      req,
    );
  }
}
